export default __webpack_public_path__ + "ea2b9b5cd5b8399d05f2e0f5ad99c045.png";